// Bankkártya sor-akciók (jog-vezérelt): szerkesztés (ceruza, payment_cards.manage) + törlés (kuka,
// payment_cards.delete). NINCS elsődlegessé-tétel (kártyának nincs elsődlegese). Külön (tesztelhető) komponens:
// a jog-kombinációk egységben ellenőrizhetők (a billing-profile-row-actions mintára, de set-primary nélkül).
import { type TFunction } from 'i18next';

import { DeleteRowAction, EditRowAction, RowActions } from '@/components/shared/list-row-actions';

export interface PaymentCardRowActionsRow {
  id: string;
}

interface PaymentCardRowActionsProps<T extends PaymentCardRowActionsRow> {
  row: T;
  canManage: boolean;
  canDelete: boolean;
  onEdit: (row: T) => void;
  onDelete: (row: T) => void;
  t: TFunction;
}

export function PaymentCardRowActions<T extends PaymentCardRowActionsRow>({
  row,
  canManage,
  canDelete,
  onEdit,
  onDelete,
  t,
}: PaymentCardRowActionsProps<T>): JSX.Element {
  if (!canManage && !canDelete) return <span className="sr-only">—</span>;

  return (
    <RowActions>
      {canManage && <EditRowAction label={t('paymentCards.edit')} onClick={() => onEdit(row)} />}
      {canDelete && (
        <DeleteRowAction label={t('paymentCards.delete')} onClick={() => onDelete(row)} />
      )}
    </RowActions>
  );
}
